export const TransitionTime = {
  Active: '0.3s',
  Disabled: '0.3s',
  Hover: '0.3s',
};
